import { render, staticRenderFns } from "./modelAnimation.vue?vue&type=template&id=4006d387&scoped=true&"
import script from "./modelAnimation.vue?vue&type=script&lang=js&"
export * from "./modelAnimation.vue?vue&type=script&lang=js&"
import style0 from "./modelAnimation.vue?vue&type=style&index=0&id=4006d387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4006d387",
  null
  
)

export default component.exports